interface OptionDef {
  id?: string | null;
  label?: string | null;
  tableReference?: string | null;
}

export interface FieldDef {
  field?: string | null;
  label?: string | null;
  type?: string | null;
  format?: string | null;
  condition?: Record<string, any> | null;
  options?: Array<OptionDef> | null;
  displayField?: string | null;
  defaultValue?: string | null;
}

export function prepareDefaultValues(
  fields: FieldDef[],
  defaultValues: Record<string, any>
): Record<string, any> {
  const prepared: Record<string, any> = {};
  if (defaultValues.id) {
    prepared.id = defaultValues.id;
  }
  fields.forEach((f) => {
    if (!f.field) return;
    const fieldKey = f.field as string;
    const displayKey = f.displayField ?? undefined;

    let rawValue: any;
    if (
      defaultValues[fieldKey] !== undefined &&
      defaultValues[fieldKey] !== null
    ) {
      rawValue = defaultValues[fieldKey];
    } else if (displayKey && defaultValues[displayKey] !== undefined) {
      rawValue = defaultValues[displayKey];
    } else if (f.defaultValue !== undefined && f.defaultValue !== null) {
      rawValue = f.defaultValue;
    } else {
      rawValue = null;
    }

    switch (f.type) {
      case 'date': {
        if (!rawValue) {
          prepared[f.field] = null;
        } else if (rawValue instanceof Date) {
          prepared[f.field] = rawValue;
        } else {
          const date = new Date(rawValue);
          prepared[f.field] = isNaN(date.getTime()) ? null : date;
        }
        break;
      }

      case 'dropdown': {
        if (rawValue == null || rawValue === '') {
          prepared[f.field] = undefined;
          break;
        }
        const matchedOption = f.options?.find(
          (opt) => (opt.tableReference || opt.label) === rawValue
        );
        prepared[f.field] = matchedOption?.id ?? '';
        break;
      }

      case 'number': {
        if (rawValue === undefined || rawValue === null || rawValue === '') {
          prepared[f.field] = undefined;
        } else {
          const num = Number(rawValue);
          prepared[f.field] = isNaN(num) ? undefined : num;
        }
        break;
      }

      default: {
        prepared[f.field] = rawValue ?? null;
      }
    }
  });

  return prepared;
}
